import {
  CreateShopDto,
  Shop,
  ShopSettings,
  UpdateShopDto,
  UpdateShopSettingsDto,
} from '../../types';
import api from './client';

// Shops Service
export const shopsService = {
  createShop: async (shopData: CreateShopDto): Promise<Shop> => {
    const response = await api.post<Shop>('/shops', shopData);
    return response.data;
  },
  getAllShops: async (): Promise<Shop[]> => {
    const response = await api.get<Shop[]>('/shops');
    return response.data;
  },
  getShopById: async (id: string): Promise<Shop> => {
    const response = await api.get<Shop>(`/shops/${id}`);
    return response.data;
  },
  /** Resolves the `:shopSlug` URL param without fetching every shop. */
  getShopBySlug: async (slug: string): Promise<Shop> => {
    const response = await api.get<Shop>(`/shops/slug/${encodeURIComponent(slug)}`);
    return response.data;
  },
  updateShop: async (id: string, updateData: UpdateShopDto): Promise<Shop> => {
    const response = await api.put<Shop>(`/shops/${id}`, updateData);
    return response.data;
  },
  deleteShop: async (id: string): Promise<void> => {
    await api.delete(`/shops/${id}`);
  },
  // The backend creates default settings on first read, so no client-side
  // fallback is needed here.
  getShopSettings: async (shopId: string): Promise<ShopSettings> => {
    const response = await api.get<ShopSettings>(`/shop-settings/shop/${shopId}`);
    return response.data;
  },
  updateShopSettings: async (id: string, updateData: UpdateShopSettingsDto): Promise<ShopSettings> => {
    const response = await api.patch<ShopSettings>(`/shop-settings/${id}`, updateData);
    return response.data;
  },
};
